import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";

import {
  ApiErrorType,
  ApiResponseError,
} from "./error-handler/api-response-error";

@Injectable({
  providedIn: "root",
})
export class HttpService {
  constructor(public http: HttpClient) {}

  public get(url, options = {}): Observable<any> {
    const optionsHeader = this.handleOptions(options);
    return this.http
      .get(url, optionsHeader)
      .pipe(map((response) => this.handleResponse(response)));
  }

  public delete(url, options = {}): Observable<any> {
    const optionsHeader = this.handleOptions(options);
    return this.http
      .delete(url, optionsHeader)
      .pipe(map((response) => this.handleResponse(response)));
  }

  public post(url, body: any = null, options = {}): Observable<any> {
    const optionsHeader = this.handleOptions(options);
    return this.http.post(url, body, optionsHeader).pipe(
      map((response) => {
        return this.handleResponse(response);
      }),
      catchError((err) => {
        this.handleErrorMessageAfterInterceptor(err);
        return throwError(err);
      }),
    );
  }

  public async postImageFile(
    url: string,
    formData: FormData,
    options: any,
  ): Promise<any> {
    const optionsHeader = this.handleOptions(options);

    this.http
      .post(url, formData, optionsHeader)
      .pipe(map((response) => this.handleResponse(response)))
      .toPromise();
  }

  public put(url, body: any = null, options = {}): Observable<any> {
    const optionsHeader = this.handleOptions(options);
    return this.http
      .put(url, body, optionsHeader)
      .pipe(map((response) => this.handleResponse(response)));
  }

  public getWithHeaders(url, options = {}): Observable<any> {
    const optionsHeader = this.handleOptions(options);
    return this.http
      .get(url, optionsHeader)
      .pipe(map((response) => this.handleResponseWithHeaders(response)));
  }

  private handleOptions(options: any = {}): any {
    if (options) options.observe = "response";
    return options;
  }

  private handleResponse(response): any {
    switch (response.status) {
      case ApiErrorType.NO_CONTENT:
        throw new ApiResponseError(ApiErrorType.NO_CONTENT, "NO CONTENT (204)");
      default:
        return response.body;
    }
  }

  private handleResponseWithHeaders(response): any {
    switch (response.status) {
      case ApiErrorType.NO_CONTENT:
        throw new ApiResponseError(ApiErrorType.NO_CONTENT, "NO CONTENT (204)");
      default:
        return response;
    }
  }

  private handleErrorMessageAfterInterceptor(errorMessage: string) {
    switch (errorMessage) {
      case ApiErrorType.CONFLICT.toString():
        throw new ApiResponseError(ApiErrorType.CONFLICT, "CONFLICT (409)");
      default:
        throw errorMessage;
    }
  }
}
